import { useObrasEmpty } from "./use-obras-empty";
import { ObrasEmptyView } from "./view-obras-empty";
import type { ObrasEmptyProps } from "./types-obras-empty";

export function ObrasEmpty(props: ObrasEmptyProps) {
  const vm = useObrasEmpty(props);

  return <ObrasEmptyView {...vm} />;
}

export type * from "./types-obras-empty";
